import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import Query from 'shared/components/Query'
import AreaPhotosView from './AreaPhotosView'
import './index.css'

export const PER_PAGE = 12
export const ESTATE_AREA_PHOTOS_QUERY = gql`
  query BookingAreaPhotosQuery (
    $id: ID!,
    $limit: Int,
    $page: Int,
    $season: String,
    $search: String,
  ) {
    booking(id: $id) {
      id
      estate {
        id
        availableAreaPhotos (
          first: $limit,
          page: $page,
          season: $season,
          search: $search,
        ) {
          edges {
            node {
              id
              ...on AreaPhotoAsset {
                name
                distanceInKm
                image(size: "monitor") { url }
                thumb: image(size: "thumb") { url }
              }
            }
          }
        }
      }
    }
  }
`

class AreaPhotos extends React.Component {
  state = {
    season: '',
    search: '',
    page: 1,
    photos: [],
    noMoreResults: false,
  }

  updatePhotoSearch(obj) {
    this.setState({...obj, noMoreResults: false})
  }

  paginateOptions(page) {
    return {
      variables: { page },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const estate = fetchMoreResult.booking.estate
        const newEdges = estate.availableAreaPhotos.edges

        if (!newEdges.length) {
          this.setState({noMoreResults: true})
          return previousResult
        }

        this.setState({page})

        const previousEdges = previousResult.booking.estate
          .availableAreaPhotos.edges

        const availableAreaPhotos = {
          ...estate.availableAreaPhotos,
          edges: [...previousEdges, ...newEdges],
        }

        return {
          booking: {
            ...previousResult.booking,
            estate: { ...estate, availableAreaPhotos },
          }
        }
      }
    }
  }

  render() {
    const {season, search, noMoreResults} = this.state

    return (
      <div className="area-photos">
        <Query
          query={ESTATE_AREA_PHOTOS_QUERY}
          variables={{
            id: this.props.booking.id,
            limit: PER_PAGE,
            page: 1,
            season,
            search,
          }}
          fetchPolicy="cache-and-network"
        >
          {({getData, fetchMore, loading}) => {
            const areaPhotos = getData('booking.estate.availableAreaPhotos.edges', [])

            return (
              <div>
                <AreaPhotosView
                  photos={areaPhotos}
                  search={search}
                  season={season}
                  loading={loading}
                  noMoreResults={noMoreResults}
                  updatePhotoSearch={this.updatePhotoSearch.bind(this)}
                  onLoadMore={(page) => fetchMore(this.paginateOptions(page))}
                />
              </div>
            )
          }}
        </Query>
      </div>
    )
  }
}

AreaPhotos.propTypes = {
  booking: PropTypes.object.isRequired,
}

export default AreaPhotos
